<template>
    <div>
        <base-input
            v-model="form.name"
            validate="required"
            name="name"
            label="Name"
            placeholder="Enter space name"/>

        <base-select
            v-model="form.access"
            :options="{private: 'Private', public: 'Public'}"
            label="Access"/>

        <space-theme-picker v-model="form.theme"/>

        <base-text-area
            v-model="form.description"
            name="description"
            label="Description"
            placeholder="Enter space description."/> <br/>

        <base-button
            :loading="loading"
            icon="fas fa-check"
            @click="submit"
            class="is-primary" text="Save"/> &nbsp;

        <base-button
            v-if="show_cancel"
            icon="fas fa-times"
            @click="$emit('cancel')"
            class="is-danger"
            text="Cancel"/>
    </div>
</template>

<script>
import SpaceThemePicker from './SpaceThemePicker.vue';

export default {
    name: 'SpaceForm',
    components: { SpaceThemePicker },
    props: {
        loading: { type: Boolean },
        init_data: { type: Object, default: () => ({}) },
        show_cancel: { type: Boolean, default: true },
    },
    data() {
        return {
            form: {
                name: '',
                access: 'private',
                description: '',
                theme: 'dark',
                ...this.init_data,
            },
        };
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$emit('submit', this.form);
            });
        },
    },
};
</script>
